import React from 'react';
import { OrderItemDesktop } from './OrderItemDesktop';
import { OrderItemTablet } from './OrderItemTablet';

export const OrderItem = ({ setActiveImage, setShowFirstItem, mainEvent }) => {
	return (
		<>
			<OrderItemTablet setShowFirstItem={setShowFirstItem} mainEvent={mainEvent} />
			<OrderItemDesktop
				setActiveImage={setActiveImage}
				setShowFirstItem={setShowFirstItem}
				mainEvent={mainEvent} 
			/>
		</>
	);
};
